import {
    AbfLoanExpanded,
    LoopPositionExpanded,
    useUnwindQuoteAndIxs,
    UnwindTokenStats,
    SwapCollateralTxnParams,
    RepayLoanTxnParams,
    useRepayLoanTransaction,
    TokenListMetadata,
    LoanCollateralExpanded,
    BuildLoanTransactionsRequest,
    SimulatedOrderedTransactions,
    ExternalUnwindQuoteParams
} from "@bridgesplit/abf-react";
import { BalanceChanges, Result } from "@bridgesplit/utils";
import { WindType } from "@loopscale/pandora-types";
import { RouteInstructionStep } from "app/utils/swapInstructions";

export type ActionProps = {
    loanExpanded: AbfLoanExpanded | undefined;
    loopPosition?: LoopPositionExpanded;
    view?: "lender" | "borrower";
};

export type UnwindOption = "collateral" | "principal";
export const OPTION_WIND_TYPE: Record<UnwindOption, WindType> = {
    collateral: WindType.Collateral,
    principal: WindType.Principal
};

export type UnwindOptionData = {
    allowed: boolean;
    windType: WindType;
    quoteResult: ReturnType<typeof useUnwindQuoteAndIxs>;
    swapInstructionSteps: RouteInstructionStep[];
    swapCollateralParams: SwapCollateralTxnParams | undefined;
    simulation: UseRepayLoopPreviewBalancesReturn;
    tokenStats: UnwindTokenStats | undefined;
    simulationFailed: boolean;
    useJitoSimulation: boolean;
    repayTxnParams: RepayLoanTxnParams | undefined;
    repayTx: ReturnType<typeof useRepayLoanTransaction>;
    hasQuoteError: boolean;
    // True after we've produced an initial usable state (success or terminal error).
    // Used to keep `loading` false during refetch cycles.
    initialLoadComplete: boolean;
    // True while refetching quotes (polling) after initial load is done.
    isFetchingQuote: boolean;
};

export type UseRepayLoopPreviewBalancesReturn = {
    previewBalances: BalanceChanges | undefined;
    isLoading: boolean;
    error: boolean;
    hasSimulated: boolean;
};

export type BaseUnwindQuoteParams = Omit<ExternalUnwindQuoteParams, "windType" | "skip">;

export type UseUnwindOptionsParams = {
    quoteParams: BaseUnwindQuoteParams;
    jitoCloseEnabled: boolean;
    loanExpanded: AbfLoanExpanded | undefined;
    loanCollateral: LoanCollateralExpanded | undefined;
    debtToRepay: number | undefined;
    resolveMetadataForMint: (mint: string | undefined) => TokenListMetadata | undefined;
    activeWallet: string | undefined;
    loopPosition: LoopPositionExpanded | undefined;
    loopName: string | undefined;
    getTransactionsWithParamsAndSimulation: (
        params: BuildLoanTransactionsRequest
    ) => Promise<Result<SimulatedOrderedTransactions>>;
};

export type UseJitoUnwindSimulationReturn = {
    previewBalances: BalanceChanges | undefined;
    error: boolean;
    isSimulating: boolean;
    hasSimulated: boolean;
};
